export function isAxiosError(error) {
    if (!error) {
        return false;
    }
    return error.isAxiosError;
}
function ExceptionFactory(tag) {
    const symbol = Symbol.for(tag + 'ExceptionSymbol');
    return {
        symbol,
        mark(error) {
            return {
                ...error,
                klass: symbol,
            };
        },
        is(error) {
            if (!error) {
                return false;
            }
            return error.klass === symbol;
        },
    };
}
function ResponseExceptionFactory(tag) {
    const symbol = Symbol.for(tag + 'ResponseExceptionSymbol');
    return {
        symbol,
        mark(error) {
            return {
                ...error,
                klass: symbol,
            };
        },
        is(error) {
            if (!error) {
                return false;
            }
            return error.klass === symbol;
        },
    };
}
export const BoException = ExceptionFactory('Backoffice');
export const WorkspaceException = ExceptionFactory('Workspace');
export const LabException = ExceptionFactory('LabException');
export const LabDataException = ResponseExceptionFactory('LabDataException');
export const CoreBaseException = ExceptionFactory('CoreBaseException');
export const CoreBaseDataException = ResponseExceptionFactory('CoreBaseDataException');
export const OpenApiException = ExceptionFactory('OpenApiException');
export const OpenApiDataException = ResponseExceptionFactory('OpenApiDataException');
export const DashboardException = ExceptionFactory('DashboardException');
export const DashboardDataException = ResponseExceptionFactory('DashboardDataException');
export const ToolException = ExceptionFactory('ToolException');
export const ToolDataException = ResponseExceptionFactory('ToolDataException');
